var _ellipse, _path, _path2, _ellipse2, _ellipse3, _ellipse4, _path3, _path4, _ellipse5, _ellipse6, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotshipment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 134,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.669,
    cy: 66.39,
    rx: 63.413,
    ry: 63.169,
    fill: "#008C04",
    fillOpacity: 0.13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.52 51.487 132 68.207 125.796 134l-71.155-17.811 17.88-64.702Z",
    fill: "#007303",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151.634 67.844 89.237 51.85a6058.801 6058.801 0 0 0-17.88 25.808c-7.007 10.178-19.219 22.658-24.449 27.626l72.98 21.446c1.338-.727 7.006-6.034 18.975-21.446 11.968-15.412 13.501-31.382 12.771-37.44Z",
    fill: "#F3F3F3",
    stroke: "#CCC",
    strokeWidth: 0.818
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.71,
    cy: 68.935,
    rx: 2.919,
    ry: 2.908,
    fill: "#007003"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.952,
    cy: 84.201,
    rx: 2.919,
    ry: 2.908,
    fill: "#007003"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.197,
    cy: 98.014,
    rx: 2.919,
    ry: 2.908,
    fill: "#007003"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.988 47.462C53.591 60.625 37.691 66.13 24.476 59.756 11.26 53.382 5.735 37.544 12.132 24.381 18.53 11.218 34.43 5.712 47.645 12.086 60.861 18.46 66.385 34.3 59.988 47.462Z",
    fill: "#007003",
    stroke: "#D2D2D2",
    strokeWidth: 0.818
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFB",
    d: "M27.664 43.554H42.26v-2.18H27.664z"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.733,
    cy: 31.559,
    rx: 4.014,
    ry: 3.998,
    fill: "#F9FAFB"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.196,
    cy: 31.559,
    rx: 4.014,
    ry: 3.998,
    fill: "#F9FAFB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35.02,
    height: 1.454,
    rx: 0.727,
    transform: "rotate(15.443 -283.05 314.07) skewX(-.114)",
    fill: "#007003"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 31.698,
    height: 1.454,
    rx: 0.727,
    transform: "rotate(15.443 -341.196 293.26) skewX(-.114)",
    fill: "#007003"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 35.021,
    height: 1.454,
    rx: 0.727,
    transform: "rotate(14.447 -239.17 363.12) skewX(-.107)",
    fill: "#007003"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotshipment);
export default __webpack_public_path__ + "static/media/notshipment.8a5b7476f433d8870a26a224bfb83f8f.svg";
export { ForwardRef as ReactComponent };